import { MessageCircle } from "lucide-react";
import { useLanguage, waLink } from "../lib/i18n";

export function WhatsAppButton() {
  const { t } = useLanguage();
  const msg =
    "Merhaba HARSPRO, araç kaplama hizmetleriniz hakkında bilgi almak istiyorum.";
  return (
    <a
      href={waLink(msg)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      data-cursor
      data-cursor-label="YAZ"
      aria-label={t.whatsapp}
      className="fixed bottom-6 right-6 z-[9990] flex h-14 w-14 items-center justify-center rounded-full bg-hars-orange text-white shadow-[0_8px_30px_rgba(240,116,42,0.5)]"
    >
      <span className="absolute inset-0 rounded-full bg-hars-orange animate-pulse-ring" aria-hidden="true" />
      <MessageCircle className="relative z-10" size={26} strokeWidth={2.2} />
    </a>
  );
}
